// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import type { UserListItem } from '@greenlight/shared';

import { UserRow } from './UserRow';

export interface UsersSectionProps {
  label: string;
  note?: string;
  users: UserListItem[];
  onInspect: (u: UserListItem) => void;
}

/**
 * A labelled section of the user directory — admins, members, or deactivated.
 * Renders nothing when there are no users to show.
 */
export function UsersSection({
  label,
  note,
  users,
  onInspect,
}: UsersSectionProps): React.JSX.Element | null {
  if (users.length === 0) return null;

  return (
    <section className="space-y-2.5">
      {/* Eyebrow header row */}
      <div className="flex items-baseline gap-2 ml-0.5">
        <h2 className="font-mono text-[10.5px] uppercase tracking-[0.08em] font-medium text-foreground">
          {label}
        </h2>
        <span className="font-mono text-[10.5px] text-muted-foreground">{users.length}</span>
        {note && (
          <span className="text-[11.5px] text-muted-foreground hidden sm:inline">{note}</span>
        )}
      </div>

      {/* User card list */}
      <div className="overflow-hidden rounded-gl-lg border border-border bg-card divide-y divide-border">
        {users.map((u) => (
          <UserRow key={u.id} user={u} onInspect={onInspect} />
        ))}
      </div>
    </section>
  );
}
